<template>
  <div class="recrutement">
    <custom-title :content="title" />
    <div v-if="loading" class="loading-job">
      <fai class="icon" icon="spinner" spin />
    </div>
    <div v-else>
      <div v-if="jobs && jobs.length > 0">
        <ul class="jobs-list">
          <li v-for="job in jobs" :key="job.id">
            <div class="job">
              <router-link :to="`/fr/job/${job.id}`" class="job-img-wrapper">
                <div class="job-img" :style="{backgroundImage: `url(${job.imgUrl})`}"></div>
              </router-link>

              <div class="job-content">
                <div class="job-title">{{job.title}}</div>
                <div class="center mt-5">
                  <router-link class="job-button" :to="`/fr/job/${job.id}`">Voir l'offre</router-link>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div v-else>Aucune offre</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      jobs: null,
      loading: true,
      title: {
       align: "center",
       level: "h2",
       title: "Nos offres d'emploi",
      }
    };
  },
  created() {
    this.fetchJobs();
  },
  methods: {
    async fetchJobs() {
      try {
        this.loading = true;
        const res = await axios.get("https://etalent.herokuapp.com/jobs/1");
        this.jobs = res.data.filter((job) => job.departmentId === 4);
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.jobs-list {
  display: grid;
  grid-gap: 50px;
  grid-template-columns: repeat(3, 1fr);
  margin: 50px auto;
  margin-top:10px;
  width: $content-width;
  max-width: $max-width;
  .job {
    background: #ebebeb;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    overflow: hidden;
    border-radius: 20px;
    display: block;
    .job-img-wrapper {
      width: 100%;
      height: 250px;
      overflow: hidden;
      cursor: pointer;
      display: block;

      .job-img {
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        width: 100%;
        height: 100%;
        transition: transform 0.4s;
        &:hover {
          transform: scale(1.2);
        }
      }
    }

    .job-content {
      padding: 20px;
      .job-title {
        font-size: 21px;
        font-weight: bold;
        color: $black;
      }
      .job-button {
        background-color: $primary;
        color: #fff;
        padding: 10px 20px;
        border-radius: 20px;
        font-size: 16px;
        transition: background-color 0.4s;
        margin: 10px 0;
        display: inline-block;
        &:hover {
          background-color: $primary-D;
        }
      }
    }
  }
}
.loading-job {
    display:flex;
    align-items: center;
    justify-content: center;
    margin:200px auto;
    .icon {
        font-size:56px;
        color:$primary;
    }
}
</style>
